import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FetchService } from '../../services/fetch.service'

@Component({selector: 'app-ticket-uploader-with-icon',
  templateUrl: './ticket-uploader-with-icon.component.html',
  styleUrls: ['./ticket-uploader-with-icon.component.scss'],
  standalone: false,
})
export class TicketUploaderWithIconComponent implements OnInit {
  /** Id */
  @Input() id: string

  /** Icon name */
  @Input() icon: string = 'plus'

  /** Link change output, when import tickets link changed */
  @Output() linkChange = new EventEmitter<string>()

  /** Us link loading? */
  loading: boolean = false

  /** Component class */
  class: string

  constructor(private fetchService: FetchService) {}

  ngOnInit(): void {
    this.id = `ticket-uploader-with-icon${this.id}`
    this.class = `color-primary icon icon-${this.icon}`
  }

  /**
   * On link change, fetch the tickets link and emit linkChange output
   * @param e Event
   */
  onChange(e: any) {
    if (e.target?.files.length) {
      this.loading = true
      this.fetchService
        .post('/file/upload', {
          file: e.target.files[0],
          uploadCategory: 'passes',
        })
        .subscribe((e: any) => {
          this.loading = false
          if (e.success) {
            this.linkChange.emit(e.data.link)
          }
        })
    }
  }
}
